<ul class="my-links">
  <li>
    <div style="cursor: pointer; font-size: 1.25rem" (click)="goBack()">
      <i class="fa fa-chevron-left"></i>
    </div>
  </li>
  <li>
    <a routerLinkActive="active" (click)="onNavigate('what-is-kachiing')" routerLink="what-is-kachiing" [routerLinkActiveOptions]="{ exact: true }"> What is Kachiing </a>
  </li>
  <li>
    <a routerLinkActive="active" (click)="onNavigate('roles')" routerLink="roles" [routerLinkActiveOptions]="{ exact: true }"> roles </a>
  </li>
  <li>
    <a routerLinkActive="active" (click)="onNavigate('how-to-earn')" routerLink="how-to-earn">
      <div class="name">How to Kachiing?</div>
    </a>
  </li>
</ul>
<router-outlet></router-outlet>
